import React from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import Booth from "@/pages/Booth";
import PaymentResult from "@/pages/PaymentResult";
import MyVendors from "@/pages/customer/MyVendors";
import VendorView from "@/pages/customer/VendorView";
import Shell from "@/pages/vendor/Shell";
import Overview from "@/pages/vendor/Overview";
import Leads from "@/pages/vendor/Leads";
import Events from "@/pages/vendor/Events";
import Profile from "@/pages/vendor/Profile";
import Forms from "@/pages/vendor/Forms";
import Analytics from "@/pages/vendor/Analytics";
import Team from "@/pages/vendor/Team";
import Account from "@/pages/vendor/Account";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminShell from "@/pages/admin/AdminShell";
import { AdminAudit, AdminOverview } from "@/pages/admin/AdminOverview";
import AdminVendors from "@/pages/admin/AdminVendors";
import AdminAttendees from "@/pages/admin/AdminAttendees";
import AdminStaff from "@/pages/admin/AdminStaff";
import AdminEventTypes from "@/pages/admin/AdminEventTypes";
import EventProfiles from "@/pages/customer/EventProfiles";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<AuthPage audience="vendor" />} />
          <Route path="/attendee" element={<AuthPage audience="attendee" />} />
          <Route path="/t/:slug" element={<Booth />} />
          <Route path="/r/:slug" element={<Booth preregister />} />
          <Route path="/me" element={<MyVendors />} />
          <Route path="/me/profiles" element={<EventProfiles />} />
          <Route path="/me/v/:leadId" element={<VendorView />} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
          <Route path="/dashboard" element={<Shell />}>
            <Route index element={<Overview />} />
            <Route path="leads" element={<Leads />} />
            <Route path="events" element={<Events />} />
            <Route path="profile" element={<Profile />} />
            <Route path="forms" element={<Forms />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="team" element={<Team />} />
            <Route path="account" element={<Account />} />
            <Route path="billing" element={<Navigate to="/dashboard/account" replace />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminShell />}>
            <Route index element={<AdminOverview />} />
            <Route path="vendors" element={<AdminVendors />} />
            <Route path="attendees" element={<AdminAttendees />} />
            <Route path="event-types" element={<AdminEventTypes />} />
            <Route path="staff" element={<AdminStaff />} />
            <Route path="audit" element={<AdminAudit />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}
